'use client'

import { Button, Container, Navigation, Spacer, Text } from '@vinted/web-ui'
import { ChevronLeft24 } from '@vinted/monochrome-icons'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  currentSlideIndex: number
  totalSlides: number
  onBackClick: () => void
}

export const SlideNavigation = ({ currentSlideIndex, totalSlides, onBackClick }: Props) => {
  const translate = useTranslate('conversation.phishing_first_time_lister_education')
  const previousPageTranslate = useTranslate('kyc_form.identity_document.photo_tips')

  return (
    <>
      <Spacer size="x-small" />
      <Navigation
        left={
          currentSlideIndex !== 0 && (
            <Container styling="tight">
              <Spacer size="small" />
              <Spacer orientation="vertical" size="small" />
              <Button
                styling="flat"
                size="small"
                iconName={ChevronLeft24}
                iconColor="greyscale-level-1"
                onClick={onBackClick}
                inline
                testId="phishing-education-back-button"
                aria={{ 'aria-label': previousPageTranslate('previous_tip') }}
              />
            </Container>
          )
        }
        body={
          <Container styling="narrow">
            <Spacer size="x-small" />
            <Text
              as="span"
              text={`${currentSlideIndex + 1}/${totalSlides}`}
              type="body"
              theme="amplified"
              aria={{
                'aria-label': translate('a11y.page_count', {
                  page_number: currentSlideIndex + 1,
                  pages_count: totalSlides,
                }),
              }}
            />
          </Container>
        }
      />
      <Spacer size="x-small" />
    </>
  )
}
